import { useFilesProvider } from "../fmanlibs/FilesProvider";
import { useSelectionProvider } from "../fmanlibs/SelectionProvider";

function plural(num:number) {
    return `${num} item` + (num==1 ? "" : "s")
}
export default function Footer(){
    const {files} = useFilesProvider()
    const {selected} = useSelectionProvider()

    const count = selected.length ? <div>{ plural(selected.length) } selected</div> : <></>
    return <footer className="small-text flex gap-16"><div>{  plural(files.length) }</div>{count}</footer>
}